module.exports = __webpack_public_path__ + "img/amx-14.501f5195.webp";